// extracted by mini-css-extract-plugin
export default {"dot":"_1d87f1a9","activeDot":"_8a4e65a5"};